import React from 'react';
import { Clock, Users, Phone, Laptop, Headphones, Baby } from 'lucide-react';

const UseCases = () => {
  const useCases = [
    {
      icon: Clock,
      title: "Temps d'Attente",
      description: "Aux urgences de l'hôpital ou en attendant un ami dans un café, ne restez jamais désœuvré. Profitez de votre temps d'attente avec une batterie chargée.",
      color: "yellow"
    },
    {
      icon: Baby,
      title: "Occuper les Enfants",
      description: "Vous avez des enfants ? Gardez-les occupés et divertis grâce à une batterie toujours disponible pour leurs jeux et vidéos préférés.",
      color: "green"
    },
    {
      icon: Phone,
      title: "Appels Importants",
      description: "Un entretien d'embauche ? Un appel client crucial ? Ne ratez jamais vos communications importantes à cause d'une batterie faible.",
      color: "yellow"
    },
    {
      icon: Laptop,
      title: "Travail à Distance",
      description: "Avec un ordinateur portable ou une tablette, continuez à travailler où que vous soyez. JYA vous permet de rester productif en déplacement.",
      color: "green"
    },
    {
      icon: Headphones,
      title: "Musique & Vidéos",
      description: "Rechargez vos écouteurs sans fil et profitez de vos contenus préférés sans déranger le voisinage dans les espaces publics.",
      color: "yellow"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            JYA s'Adapte à Votre Vie
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Que vous soyez en déplacement, au travail, ou en famille, nos batteries sont là pour vous accompagner dans tous vos moments
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {useCases.map((useCase, index) => {
            const Icon = useCase.icon;
            const bgColor = useCase.color === 'yellow' ? 'bg-yellow-50' : 'bg-green-50';
            const iconBgColor = useCase.color === 'yellow' ? 'bg-yellow-100' : 'bg-green-100';
            const iconColor = useCase.color === 'yellow' ? 'text-yellow-600' : 'text-green-600';
            const hoverBorder = useCase.color === 'yellow' ? 'hover:border-yellow-400' : 'hover:border-green-400';
            
            return (
              <div 
                key={index}
                className={`${bgColor} p-8 rounded-2xl border-2 border-transparent ${hoverBorder} transition-all duration-300 hover:shadow-xl hover:-translate-y-1 group`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className={`w-16 h-16 ${iconBgColor} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className={`w-8 h-8 ${iconColor}`} />
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {useCase.title}
                </h3>
                
                <p className="text-gray-700 leading-relaxed">
                  {useCase.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-yellow-100 to-green-100 p-8 rounded-2xl border-2 border-yellow-300 max-w-3xl">
            <p className="text-gray-800 text-lg font-medium mb-2">
              Ne laissez plus jamais une batterie faible vous limiter
            </p>
            <p className="text-gray-600">
              Avec JYA, restez connecté, productif et serein en toutes circonstances
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCases;
